import React, { FC } from 'react'
import { Link, useParams } from 'react-router-dom'

interface ProductNameCellProps {
  productData: {
    id: number
    name: string
    platform_product?: {
      id: number
      name: string
      platform: number
    }
  }
}

export const ProductNameCell: FC<ProductNameCellProps> = ({ productData }) => {
  const params = useParams()
  
  const productName = productData?.platform_product?.name || ''
  const variantName = productData?.name || ''
  
  // Don't show variant name if it's "Default Title" or same as product name or empty
  const shouldShowVariant = 
    variantName &&
    variantName !== 'Default Title' &&
    variantName !== productName &&
    variantName !== ''

  return (
    <div>
      <Link
        className="fw-bold text-info mb-0 text-decoration-none"
        to={`/product-variant-detail/${productData?.id}/platform/${productData?.platform_product?.platform}/product/${productData?.platform_product?.id}/${params.platformId}`}
      >
        <h5 className="text-start mb-0 text-preserve-spacing">{productName}</h5>
      </Link>
      {shouldShowVariant && (
        <small className="fw-bold text-preserve-spacing">Variant : {variantName}</small>
      )}
    </div>
  )
}
